<div class="container">
    <app-header></app-header>
    <app-pages></app-pages>
    <app-footer></app-footer>
</div>